import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { primaryColors, StyledFlex } from '@tryhackme/thm-ui-components';
import { useState } from 'react';
import { sanitizeAndRenderHtmlString } from 'src/common/helpers';
import { StyledAccordion, StyledAccordionContent, StyledAccordionTrigger, StyledAccordionWrapper, StyledCategoryButton, StyledChevron, StyledContainer, StyledQuestion, StyledTitle } from './sims-faq.styles';
import type { SimsFaqProps } from './sims-faq.types';
export const SimsFaq = ({
  faqData,
  containerMargins
}: SimsFaqProps) => {
  const [activeCategory, setActiveCategory] = useState(() => faqData[0]);
  if (faqData.length === 0) {
    return null;
  }

  // This should never happen due to the check above, but TypeScript needs assurance
  if (!activeCategory) {
    return null;
  }
  return <StyledContainer $margins={containerMargins} data-sentry-element="StyledContainer" data-sentry-component="SimsFaq" data-sentry-source-file="sims-faq.tsx">
      <StyledFlex gap="2.8rem" alignItems="center" flexDirection="column" data-sentry-element="StyledFlex" data-sentry-source-file="sims-faq.tsx">
        <StyledTitle data-sentry-element="StyledTitle" data-sentry-source-file="sims-faq.tsx">FAQs</StyledTitle>
        <StyledFlex gap="1.6rem" alignItems="center" justifyContent="center" data-sentry-element="StyledFlex" data-sentry-source-file="sims-faq.tsx">
          {faqData.map(category => <StyledCategoryButton key={category.id} $active={category.id === activeCategory.id} onClick={() => {
          setActiveCategory(category);
        }}>
              {category.label}
            </StyledCategoryButton>)}
        </StyledFlex>
      </StyledFlex>
      <StyledAccordionWrapper data-sentry-element="StyledAccordionWrapper" data-sentry-source-file="sims-faq.tsx">
        {activeCategory.questions.map(item => <StyledAccordion value={item.title} key={item.title}>
            <StyledAccordionTrigger>
              <StyledFlex alignItems="baseline" gap="1.2rem" justifyContent="flex-start" flexWrap="no-wrap">
                <FontAwesomeIcon style={{
              width: '1.6rem',
              height: '1.6rem'
            }} icon={item.icon} color={primaryColors.main} />
                <StyledQuestion>{item.title}</StyledQuestion>
              </StyledFlex>
              <StyledChevron />
            </StyledAccordionTrigger>
            <StyledAccordionContent>
              {/<[^>]+>/.test(item.answer) ? sanitizeAndRenderHtmlString(item.answer) : <p style={{
            whiteSpace: 'pre-wrap'
          }}>{item.answer}</p>}
            </StyledAccordionContent>
          </StyledAccordion>)}
      </StyledAccordionWrapper>
    </StyledContainer>;
};